import { Button, Modal, MuiThemeProvider, Paper, Typography, withStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from 'components/TrustCenter/store/actions';
import {
    PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME,
    PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME
} from 'components/UI/Button/ButtonMuiTheme';
import ProviderSearch from './ProviderSearch/Sync/ProviderSearch';
import ConnectionTypeSearch from './AddConnectionSearch/ConnectionTypeSearch';
import css from './AddConnection.module.css';
import cs from 'classnames';
import { isNotBlank } from 'components/Common/Utils/StringUtils';
import * as Constants from 'constants/Constants';
import ProviderAsyncSearch from './ProviderSearch/Async/ProviderAsyncSearch';

const styles = (theme) => ({
    paper: {
        position: 'absolute',
        borderRadius: 5,
        width: '630px',
        boxShadow: theme.shadows[5],
        padding: '10px 20px',
        outline: 'none'
    }
});

function getModalStyle() {
    const top = 18;
    const left = 30;

    return {
        top: `${top}%`,
        left: `${left}%`
    };
}

const AddConnection = (props) => {
    const {
        classes,
        parentProps,
        showModal,
        updateSelectedAccountType,
        selectedAccountType,
        isTitanServiceEnabled
    } = props;

    const [selectedProvider, setSelectedProvider] = useState('');
    const [selectedProviderAccountId, setSelectedProviderAccountId] = useState('');

    const [connectionType, setConnectionType] = useState('');

    const [modalStyle] = useState(getModalStyle);

    const handleProviderChange = (providerId) => {
        setSelectedProvider(providerId);
        setConnectionType(selectedAccountType);
    };

    const handleProviderV2Change = (prooviderAccountId) => {
        setSelectedProviderAccountId(prooviderAccountId);
        setConnectionType(selectedAccountType);
    };

    const handleClose = () => {
        setSelectedProvider('');
        updateSelectedAccountType('');
        setConnectionType('');
        props.handleClose();
    };

    useEffect(() => {
        if (isNotBlank(selectedAccountType)) {
            setSelectedProvider('');
        }
    }, [selectedAccountType]);

    const createConnection = () => {
        setSelectedProvider('');
        updateSelectedAccountType('');
        if (connectionType === Constants.ACCOUNT_TYPE_VENDOR) {
            parentProps.history.push(
                `agreements/${connectionType.toUpperCase()}/${selectedProvider?.name}/create`
            );
        } else {
            parentProps.history.push(
                `provider/${
                    isTitanServiceEnabled ? selectedProvider : selectedProviderAccountId
                }/create-connection${isTitanServiceEnabled ? `/${connectionType}` : ''}`
            );
        }
    };

    return (
        <div className="full-width">
            <Modal open={showModal}>
                <Paper style={modalStyle} className={classes.paper}>
                    <Typography variant="h6" id="modal-title">
                        ADD CONNECTION
                    </Typography>
                    <div className="row">
                        <div className="col-sm-5">
                            <ConnectionTypeSearch />
                        </div>
                        <div className="col-sm-7">
                            {selectedAccountType === Constants.ACCOUNT_TYPE_SHIPPER ? (
                                <ProviderAsyncSearch
                                    sendSelectedProvider={handleProviderChange}
                                    sendSelectedProviderAccountId={handleProviderV2Change}
                                />
                            ) : (
                                <ProviderSearch
                                    sendSelectedProvider={handleProviderChange}
                                    sendSelectedProviderAccountId={handleProviderV2Change}
                                />
                            )}
                        </div>
                    </div>
                    <div className="row justify-content-end">
                        <div className={cs('col-sm-auto', css.actionButton)}>
                            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME}>
                                <Button id={'cancel'} onClick={() => handleClose()}>
                                    CANCEL
                                </Button>
                            </MuiThemeProvider>
                            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME}>
                                <Button
                                    disabled={selectedProvider === ''}
                                    onClick={() => createConnection()}
                                    id={'continue'}
                                >
                                    CONTINUE
                                </Button>
                            </MuiThemeProvider>
                        </div>
                    </div>
                </Paper>
            </Modal>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        selectedAccountType: state.connection.selectedAccountType,
        isTitanServiceEnabled: state.agreementV2.isTitanServiceEnabled
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateSelectedAccountType: (accountType) =>
            dispatch(actions.updateSelectedAccountType(accountType))
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddConnection))
);
